/**
 * 存儲老師的tokens
 * @param tokenList
 */
export const saveTeacherTokens = (tokenList) => {
  if (!Array.isArray(tokenList)) {
    throw new Error('teacher tokens必須是一個數組');
  }

  if (!tokenList.length) {
    return;
  }

  sessionStorage.setItem('teacher_tokens', tokenList.join(','));
};

/**
 * 獲取存儲的老師tokens
 * @returns {string[]|*[]}
 */
export const getTeacherTokens = () => {
  const teacherTokens = sessionStorage.getItem('teacher_tokens') || '';
  if (!teacherTokens) {
    return [];
  }

  return teacherTokens.split(',');
};
